import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Address } from '@/models/locations';
import { PickupDeliveryToggleMode } from '@/components/CmgPickupDeliveryToggle/cmg-pickup-delivery-toggle';
import { Restaurant } from '@/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { CheckoutEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgCheckoutHeader',
})
export default class CmgCheckoutHeader extends Vue {
  @Prop({ type: Object })
  address?: Address;

  @Prop({ type: Object })
  restaurant?: Restaurant;

  get isPickup(): boolean {
    return this.$services.order.isPickingUp();
  }

  async onTogglePickupDelivery(mode: PickupDeliveryToggleMode, event: any) {
    switch (mode) {
      case 'pickup':
        this.$services.googleAnalytics.sendCustomEvent({ 
          category: AnalyticsEventCategory.Behavior,
          action: AnalyticsEventAction.Toggle,
          label: AnalyticsEventLabel.CheckoutPickup,
        });

        if (!this.$store.state.restaurant.selectedRestaurant?.crewTipPickupEnabled && this.$store.state.featureFlags.orderingStatus?.isCrewTippingEnabled) {
          this.$services.checkout.setCrewTip(0.00, false);
        }
        this.$services.order.switchToPickup();
        this.sendAdobeCheckoutEvent();
        break;
      case 'delivery':
        this.$services.googleAnalytics.sendCustomEvent({ 
          category: AnalyticsEventCategory.Behavior,
          action: AnalyticsEventAction.Toggle,
          label: AnalyticsEventLabel.CheckoutDelivery,
        });

        const savedAddresses = this.$appStore.state.customer.deliveryAddresses;
        if (savedAddresses.length) {
          this.$services.order.setDeliveryAddress(savedAddresses[0]);
          return;
        }
        this.$services.ui.setLastSelectedElement('delivery-select');
        this.$services.ui.setModalVisibility('findAChipotle', true, { mode: 'delivery' });
        this.$services.ui.firstFocus();
        break;
      default:
        this.$services.logger.unreachable('unknown pickup/delivery mode!', { mode });
    }
  }

  private sendAdobeCheckoutEvent(): void {
    this.$services.analytics.send(new CheckoutEvent())
  }
}